import { render, staticRenderFns } from "./pointLearn.vue?vue&type=template&id=c82e31d2&scoped=true"
import script from "./pointLearn.vue?vue&type=script&lang=js"
export * from "./pointLearn.vue?vue&type=script&lang=js"
import style0 from "./pointLearn.vue?vue&type=style&index=0&id=c82e31d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82e31d2",
  null
  
)

export default component.exports